export default {
	module: 'plans',
	actions: {
		list: true,
		create: true,
		dynamicPaths: [
			{
				paths: {
					'/plans/edit/:id': true,
				},
				keys: {
					':id': 3
				}
			},
			{
				paths: {
					'/plans/select/:id': true,
				},
				keys: {
					':id': 3
				}
			}

		]
	}
}
